import type { ImageElementData, VideoElementData } from 'components/Canvas/RegionThumb/common';
import { makeAutoObservable } from 'mobx';

export interface MediaState {
  url: string;
  element: HTMLImageElement | HTMLVideoElement | undefined; // adding undefined here because of the underlying code. codeowners please review this
  setMedia(url: string, elem: HTMLImageElement | HTMLVideoElement | undefined, type: MediaState['mediaType']): void;
  imageData: ImageElementData | VideoElementData | null;
  reset(): void;
  mediaType: 'image' | 'video' | undefined; // adding undefined here because of the underlying code
}

export const makeMediaState = (): MediaState => {
  const shared: MediaState = {
    url: '',
    element: undefined,
    mediaType: undefined,

    reset: (): void => {
      shared.element = undefined;
      shared.url = '';
    },

    setMedia: (url: string, elem: HTMLImageElement | HTMLVideoElement, type: 'image' | 'video'): void => {
      shared.element = elem;
      shared.url = url;
      shared.mediaType = type;
    },

    get imageData(): ImageElementData | VideoElementData | null {
      if (!shared.element) {
        return null;
      }
      const { width, height } = shared.element;

      if (shared.element instanceof HTMLImageElement) {
        return {
          width,
          height,
          image: shared.element,
          url: shared.url,
        };
      }
      if (shared.element instanceof HTMLVideoElement) {
        return {
          width,
          height,
          video: shared.element,
          url: shared.url,
        };
      }
      return null;
    },
  };
  return makeAutoObservable(shared, undefined, { autoBind: true });
};
